import styled from 'styled-components';

const height = 6;

export default styled.span<{ open: boolean }>`
  display: inline-block;
  width: ${height}px;
  height: ${height}px;
  will-change: transform;
  position: relative;
  overflow: visible;
  transform: ${props => (props.open ? `translateY(-5%);` : `translateY(25%);`)};
  transition: 0.3s;
  &:before {
    border-radius: ${height / 14}px;
    display: block;
    content: ' ';
    width: ${height}px;
    height: ${height / 7}px;
    background: #999;
    transition: 0.3s;
    transform: ${props => (!props.open ? `rotate(-45deg)` : `rotate(45deg)`)};
    position: absolute;
    transform-origin: ${height / 14}px center;
    left: 0;
  }

  &:after {
    border-radius: ${height / 14}px;
    display: block;
    content: ' ';
    width: ${height}px;
    height: ${height / 7}px;
    background: #999;
    transition: 0.3s;
    transform: ${props => (!props.open ? `rotate(-135deg)` : `rotate(-225deg)`)};
    position: absolute;
    transform-origin: ${height / 14}px center;
    left: 0;
  }
`;
